import type { IntlShape } from 'react-intl'

export function getSkyLoungeLabel(intl: IntlShape): string {
  return intl.formatMessage({
    id: 'TijeSn2zIRho1tPgdk55',
    defaultMessage: 'Economy Extra',
  })
}

export function getIllustrativePurposesOnlyLabel(intl: IntlShape): string {
  return intl.formatMessage({
    id: 'kVEBo4WZee0940CUmUSj',
    defaultMessage: 'Illustrative purposes only',
  })
}
